import { makeSceneDoc } from './kit.js';

/**
 * 店铺通用做法：一家铺子 = 一个房间 + 一排柜台 + 几件家什。
 * 进门的 communicative 由 portal 负责，具体的买卖都挂在 shop_counter 的 state.kind 指名的 "shopId" 上。
 */
export function shopScene(spec) {
  const w = spec.w || 22;
  const h = spec.h || 18;
  const floor = spec.floor || '.';
  const shop = spec.shop || spec.id;
  const counters = spec.counters || [{ gx: Math.floor(w / 2) - 2, gy: 3, len: 4 }];

  return makeSceneDoc({
    id: spec.id,
    name: spec.name,
    region: 'city',
    tier: 2,
    indoor: true,
    kind: 'shop',
    node: spec.id,
    shopId: shop,
    need: spec.need || null,
    cost: spec.cost || null,
    hours: spec.hours || null,
    desc: spec.desc || '',
    w, h,
    fill: floor,
    spawn: spec.spawn || { gx: Math.floor(w / 2), gy: h - 3 },
    draw(b, rng) {
      b.frame(0, 0, w, h, '#');
      b.rect(1, 1, w - 2, h - 2, floor);
      const d = spec.door == null ? Math.floor(w / 2) : spec.door;
      b.set(d, h - 1, '+');
      if (typeof spec.draw === 'function') spec.draw(b, rng);
    },
    props: [
      ...counters.flatMap((c) => {
        const out = [];
        for (let i = 0; i < (c.len || 1); i += 1) {
          out.push({
            type: 'shop_counter',
            gx: (c.gx || 0) + i,
            gy: c.gy || 3,
            state: { kind: c.kind || spec.kind || shop, shop, owner: spec.owner || '' },
          });
        }
        return out;
      }),
      ...(spec.props || []),
    ],
    portals: spec.portals || [],
  });
}
